export function sendToExtension(type,payload){var callback=window.__ddBrowserSdkExtensionCallback;callback&&callback({type:type,payload:payload})}